// Packages
import React from "react";
import PropTypes from "prop-types";

// Styles
import {
  StyledFormControl,
  StyledAutocomplete,
  StyledHelperText,
} from "./AutocompleteField.styles";
import { StyledTextField } from "../TextField/TextField.styles";

// Assets
import useIcons from "../../../assets/icons";

// Components
import FormLabel from "../FormLabel";

const AutocompleteField = (props) => {
  const {
    label,
    tooltipTitle,
    options = [],
    selectedValue,
    error,
    handleInputChange,
    disabled,
    warningLabel,
    ...rest
  } = props;
  const { IconSearch } = useIcons();

  const errorMessage = error?.message || error?.label?.message || error?.value?.message || '';

  return (
    <StyledFormControl fullWidth error={!!error}>
      <StyledAutocomplete
        popupIcon={<IconSearch />}
        options={options}
        value={selectedValue || null}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.label}
        disabled={disabled}
        renderInput={(params) => (
          <StyledTextField
            onChange={handleInputChange}
            label={<FormLabel label={label} className={warningLabel ? "danger" : ""} tooltipTitle={tooltipTitle} error={error} />}
            {...params}
            variant="standard"
            error={!!error}
          />
        )}
        {...rest}
      />
      {error && errorMessage && <StyledHelperText>{errorMessage}</StyledHelperText>}
    </StyledFormControl>
  );
};

AutocompleteField.propTypes = {
  label: PropTypes.string,
  tooltipTitle: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  error: PropTypes.any,
};

export default AutocompleteField;
